import React from 'react'

import { useWatch } from 'react-hook-form'

export default ({ name, render, defaultValue }) => {
  const value = useWatch({ name, defaultValue })
  return <React.Fragment>{render(value)}</React.Fragment>
}
